import { BrowserRouter, Route, Routes } from "react-router-dom";
import routes from "config/routes";
import ApiResponseModal from "common/Modals/ApiErrorModal";
import QuestionnaireContextProvider from "components/Assessment/QuestionnaireContext";
function App(props: any) {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          {routes.map((route: any, index: any) => {
            return (
              <Route
                key={index}
                path={route.path}
                element={
                  /**
                   * Every active route gets one questionnaire context so its
                   * screens share one socket without retaining assessment state.
                   */
                  <QuestionnaireContextProvider>
                    <route.component
                      name={route.name}
                      {...props}
                      {...route.props}
                    />
                    <ApiResponseModal />
                  </QuestionnaireContextProvider>
                }
              />
            );
          })}
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
